<template>
  <div>
    <div v-if="GET_ACCOUNT_DATA.id == 1 || has_perm('view_approval_apartment_resident')"
      style="border: 0px solid black; width:100%;">
      <div class="welcome" style="border: 0px solid red;">
        <row style="border:0px solid green;position: inherit;display:contents;width:100%;">
          <!-- Search container -->
          <div class="box box-success">
            <div class="box-header with-border">
              <h3 class="box-title">{{ $t("search.title") }}</h3>
            </div>
            <div class="box-body">
              <div class="row" style="margin-bottom: 10px;">
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <input
                    type="text"
                    class="form-control"
                    :placeholder="$t('search.title')"
                    v-model="search.searchText"
                    v-on:keyup.enter="onSearch"
                  />
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3">
                  <button
                    type="button"
                    class="btn btn-labeled btn-success"
                    @click="onSearch"
                  >
                    <span class="btn-label">
                      <i class="glyphicon glyphicon-search"></i>
                    </span>
                    {{ $t("search.search_button") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!--  -->
          <div class="box box-primary">
            <div class="box-header with-border">
              <div
                style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;"
              >
                <b>{{ $t("memberRegistrationList.title") }}</b>
              </div>
            </div>
            <div class="box-body">
              <div class="" style="display: flex; padding: 0 15px">
                <span
                  v-for="(item, index) in tabList"
                  :key="item + index"
                  :class="
                    `${
                      index !== tabList.length - 1
                        ? 'customer-type-class border-right'
                        : 'customer-type-class'
                    }`
                  "
                  @click="onChangeTab(item)"
                >
                  <span
                    :class="
                      item.value === tabSelect ? 'customer-type-select' : ''
                    "
                    style="white-space: nowrap;"
                  >
                    {{ $t(item.text) }} ({{ item.total }})
                  </span>
                </span>
              </div>
              <!-- B-Table Start -->
              <b-table
                :items="gridDataList"
                :fields="gridColumns"
                class="mt-3"
                outlined
                responsive
              >
                <template #head()="scope">
                  <div>{{ $t(scope.label) }}</div>
                </template>
                <template #cell(memberName)="row">
                  {{ row.item.memberName }}
                  <div
                    v-if="
                      has_perm('update_maintenance') &&
                        tabSelect === apartmentResidentApprovalEnum.UNAPPROVED
                    "
                    class="show-when-hovered"
                    style="display: flex; white-space: nowrap;"
                  >
                    <span
                      class="action-approve hover-action"
                      @click="
                        updateApprovalApartmentResident(
                          apartmentResidentApprovalEnum.APPROVED,
                          row.item
                        )
                      "
                      ><small>{{
                        $t("approvalApartmentResident.approval")
                      }}</small></span
                    >
                    <span class="action-space-border">|</span>
                    <span
                      class="action-cancel hover-action"
                      @click="
                        updateApprovalApartmentResident(
                          apartmentResidentApprovalEnum.CANCELED,
                          row.item
                        )
                      "
                      ><small>{{
                        $t("approvalApartmentResident.cancel")
                      }}</small></span
                    >
                  </div>
                </template>
              </b-table>
              <!-- B-Table End -->
            </div>
          </div>
        </row>
      </div>
    </div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
    <!--  -->
    <lte-modal
      v-show="isModalVisible"
      @onConfirm="confirmUpdateApprovalApartmentResident"
      @close="closeModal"
      v-for="obj in objModal"
      :key="obj.id"
      :item="obj"
    ></lte-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import LTEModal from "@/components/LTEModal.vue";
import utils from '@/lib/utils';
import Enum from "../../../enum/enum";
export default {
  components: {
    // "lte-button": LTEButton,
    loading: Loading,
    "lte-modal": LTEModal
  },
  data: () => ({
    isLoading: false,
    search: {
      searchText: null
    },
    gridDataList: [],
    gridColumns: [
      {
        label: "common.nonumber",
        key: "nonumber",
        class: "text-center "
      },
      {
        label: "apartment.apartment_code",
        key: "apartmentCode",
        class: "text-center "
      },
      {
        label: "memberRegistrationList.memberName",
        key: "memberName",
        class: "text-left "
      },
      {
        label: "customer.email",
        key: "memberEmail",
        class: "text-center "
      },
      {
        label: "customer.phone",
        key: "memberPhone",
        class: "text-center "
      },
      {
        label: "customer.identificationnumber",
        key: "identificationnumber",
        class: "text-center "
      },
      {
        label: "memberRegistrationList.registerDate",
        key: "registerDate",
        class: "text-center "
      }
    ],
    paginateData: {
      totalItem: 1,
      currentPage: 1,
      pageSize: 1,
      totalPage: 1
    },
    tabList: [
      {
        value: Enum.ApartmentResidentApprovalEnum.UNAPPROVED,
        text: "memberRegistrationList.statusList.UNAPPROVED",
        total: 0
      },
      {
        value: Enum.ApartmentResidentApprovalEnum.APPROVED,
        text: "memberRegistrationList.statusList.APPROVED",
        total: 0
      },
      {
        value: Enum.ApartmentResidentApprovalEnum.CANCELED,
        text: "memberRegistrationList.statusList.CANCELED",
        total: 0
      }
    ],
    tabSelect: Enum.ApartmentResidentApprovalEnum.UNAPPROVED,
    apartmentResidentApprovalEnum: Enum.ApartmentResidentApprovalEnum,
    //
    isModalVisible: false,
    apartmentResidentSelect: null,
    approvalStatusSelect: null,
    objModal: [
      {
        title: "common.delete_modal.btnYes",
        body: "common.delete_modal.content",
        buttonNo: "common.delete_modal.btnNo",
        buttonYes: "common.delete_modal.btnYes",
        styleType: "default"
      }
    ]
  }),
  watch: {
    GET_APPROVAL_APARTMENT_RESIDENT_LIST_DATA: function() {
      let paginate = this.GET_APPROVAL_APARTMENT_RESIDENT_LIST_DATA.paginate;
      this.paginateData = {
        totalItem: paginate.totalItem,
        currentPage: paginate.currentPage,
        pageSize: paginate.pageSize,
        totalPage: paginate.numPages
      };
      this.gridDataList = [];
      let data = this.GET_APPROVAL_APARTMENT_RESIDENT_LIST_DATA.results;
      data.forEach((e, i) => {
        let nonumber = i + 1 + (paginate.currentPage - 1) * paginate.pageSize;
        let item = {
          nonumber: nonumber,
          apartmentCode: e.apartment_data.apartment_code,
          memberName: e.resident_data.full_name,
          memberEmail: e.resident_data.email,
          memberPhone: e.resident_data.phone,
          identificationnumber: e.resident_data.identificationnumber,
          registerDate: utils.formatSqlDate(e.date_created, null, "DD/MM/YYYY"),
          id: e.id
        };
        this.gridDataList.push(item);
      });
    },
    GET_NUMBER_APPROVAL_APARTMENT_RESIDENT_DATA: function() {
      let data = this.GET_NUMBER_APPROVAL_APARTMENT_RESIDENT_DATA;
      data.forEach(e => {
        let index = this.tabList.findIndex(x => x.value === e.value);
        if (index !== -1) {
          this.tabList[index].total = e.total;
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_APPROVAL_APARTMENT_RESIDENT_LIST_DATA",
      "GET_NUMBER_APPROVAL_APARTMENT_RESIDENT_DATA"
    ])
  },
  methods: {
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    onChangeTab: function(data) {
      this.tabSelect = data.value;
      this.getApprovalApartmentResidentList(1);
    },
    onSearch: function() {
      this.getNumberApprovalApartmentResident();
      this.getApprovalApartmentResidentList(1);
    },
    getApprovalApartmentResidentList: function(page) {
      let filter = {
        params: {
          approvedStatus: this.tabSelect,
          page: page,
          searchText: this.search.searchText
        }
      };
      this.isLoading = true;
      this.GET_APPROVAL_APARTMENT_RESIDENT_LIST(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    getNumberApprovalApartmentResident: function() {
      let filter = {
        params: {
          searchText: this.search.searchText
        }
      };
      this.isLoading = true;
      this.GET_NUMBER_APPROVAL_APARTMENT_RESIDENT(filter)
        .then(
          function() {
            this.isLoading = false;
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    updateApprovalApartmentResident: function(value, data) {
      this.isModalVisible = true;
      this.apartmentResidentSelect = data;
      this.approvalStatusSelect = value;
      if (this.approvalStatusSelect ===Enum.ApartmentResidentApprovalEnum.APPROVED) {
        this.objModal[0].body = 'approvalApartmentResident.notiApprovalApartmentResident'
      }
      if (this.approvalStatusSelect ===Enum.ApartmentResidentApprovalEnum.CANCELED) {
        this.objModal[0].body = 'approvalApartmentResident.notiCancelApartmentResident'
      }
    },
    closeModal: function() {
      this.isModalVisible = false;
    },
    confirmUpdateApprovalApartmentResident: function() {
      let approvalData = {
        id: this.apartmentResidentSelect.id,
        value: this.approvalStatusSelect
      };
      this.isLoading = true;
      this.UPDATE_APARTMENT_APPROVAL_STATUS(approvalData)
        .then(
          function() {
            this.isLoading = false;
            this.closeModal()
            this.getNumberApprovalApartmentResident();
            this.getApprovalApartmentResidentList(this.paginateData.currentPage);
          }.bind(this)
        )
        .catch(
          function() {
            this.isLoading = false;
          }.bind(this)
        );
    },
    ...mapActions([
      "GET_APPROVAL_APARTMENT_RESIDENT_LIST",
      "GET_NUMBER_APPROVAL_APARTMENT_RESIDENT",
      "UPDATE_APARTMENT_APPROVAL_STATUS"
    ])
  },
  mounted() {
    this.getNumberApprovalApartmentResident();
    this.getApprovalApartmentResidentList(1);
  }
};
</script>
<style scoped>
.customer-type-class {
  padding: 5px 15px;
  cursor: pointer;
}
.border-right {
  border-right: 1px solid #000000;
}
.customer-type-select {
  font-weight: bold;
  color: #006ad4;
}

.hover-action {
  cursor: pointer;
}
.hover-action:hover {
  text-decoration: underline;
}
.action-approve {
  color: blue;
}
.action-cancel {
  color: red;
}
.action-space-border {
  margin: 0 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApprovalApartmentResidentList.vue